import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import about1 from '../../images/about/about_image_9.png'
import SimpleParallax from 'simple-parallax-js'

const About = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    useEffect(() => {
        // initialize simple-parallax on any images with a data-parallax attribute
        const elems = document.querySelectorAll('.about_image_1 img[data-parallax]');
        const instances = [];
        elems.forEach((el) => {
            let opts = {};
            try { opts = JSON.parse(el.getAttribute('data-parallax')); } catch (e) { opts = {} }
            // map y to orientation (simple-parallax accepts 'up'/'down')
            const orientation = (opts.y && Number(opts.y) < 0) ? 'up' : 'down';
            const delay = opts.smoothness ? Math.max(0, (10 - Number(opts.smoothness)) / 10) : 0.2;
            const scale = opts.scale ? Number(opts.scale) : 1.06;
            const instance = new SimpleParallax(el, { orientation, scale, delay, overflow: false });
            instances.push(instance);
        });
        return () => instances.forEach(i => { try { i.destroy(); } catch (e) {} });
    }, []);

    return (
        <section className="about_section section_space">
            <div className="container">
                <div className="row align-items-center justify-content-lg-between">
                    <div className="col-lg-6">
                        <div className="about_image_1">
                            <img src={about1} alt="Techco - About" className="about_main_image" />
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="about_content">
                            <div className="heading_block">
                                <div className="heading_focus_text">
                                    We are 😃
                                    <span className="badge bg-secondary text-white">Kemstec</span>
                                </div>
                                <h2 className="heading_text">
                                    Leading IT Solutions & Office Security Company in Ghana
                                </h2>
                                <p className="heading_description mb-0">
                                    Kemstec Company Ltd is a Limited Liability Company registered in Ghana with five years' experience in Electrical/Electronic Services, Solar Energy Systems, Fire Safety Solutions, Card Technologies, ICT System Integration, Surveillance Systems, Environmental Monitoring Systems and Construction/Road Works.
                                </p>
                            </div>
                            <ul className="icon_list unordered_list_block mb-5">
                                <li>
                                    <span className="icon_list_icon">
                                        <i className="fa-solid fa-circle fa-fw"></i>
                                    </span>
                                    <span className="icon_list_text">
                                        Experts in IT System Integration & Office Security Systems
                                    </span>
                                </li>
                                <li>
                                    <span className="icon_list_icon">
                                        <i className="fa-solid fa-circle fa-fw"></i>
                                    </span>
                                    <span className="icon_list_text">
                                        Strategic Partners: HP, Oracle, Microsoft, Dell, Tyco Fire Safety
                                    </span>
                                </li>
                                <li>
                                    <span className="icon_list_icon">
                                        <i className="fa-solid fa-circle fa-fw"></i>
                                    </span>
                                    <span className="icon_list_text">
                                        Serving clients across Ghana and West Africa
                                    </span>
                                </li>
                            </ul>
                            <ul className="btns_group unordered_list p-0 justify-content-start">
                                <li>
                                    <Link onClick={ClickHandler} to="/about" className="btn">
                                        <span className="btn_label" data-text="Get Started">Get Started</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;